import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import SideMenu from "../sideMenu";
import { capitalize } from "lodash";
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Tooltip,
  Typography,
  message,
} from "antd";
import TaxmasterForm from "./taxmasterform";
import config from "../../../config";
import { useDispatch, useSelector } from "react-redux";
import { tableIcons } from "../../../tableIcons";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { TablePagination } from "@material-ui/core";
import CustomTable from "../../table";
import { PlusOutlined } from "@ant-design/icons";
import { useAccess } from "../../../provider/AccessProvider";
import { TAXACCESS } from "../../../utils/constant";
import { FiEdit } from "react-icons/fi";
const TaxMasterpage = (props) => {
  const [taxList, setTaxList] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [show, setShow] = React.useState(false);
  const [form] = Form.useForm();
  const [mode, setMode] = React.useState("add");
  const dispatch = useDispatch();
  const shopDetails = useSelector((state) => state.shopDetails);
  const shopId = shopDetails.shopId;
  const [initialValues, setInitialValues] = React.useState({});
  const [loading, setLoading] = useState(true);
  const customTaxType = useSelector((state) => state.shopDetails.customTaxType);
  const [customTaxName, setCustomTaxName] = React.useState("");
  const [taxLoading, setTaxLoading] = useState(false);
  const access = useAccess(TAXACCESS);
  const [tableColumns, setTableColumns] = useState([
    {
      title: "Tax Name",
      dataIndex: "taxName",
      render: (taxName) => {
        return (
          <div>
            <span>{capitalize(taxName)}</span>
          </div>
        );
      },
    },
    {
      title: "Tax Type",
      render: (rowData) => {
        return (
          <div className="comma-separator">
            {rowData.taxType.map((taxType, index) => {
              const label =
                customTaxType.find((customTax) => customTax.taxId === taxType)
                  ?.label || taxType;
              return <span key={index}>{capitalize(label)}</span>;
            })}
          </div>
        );
      },
    },
    {
      title: "GST",
      render: (rowData) => {
        return <div>{rowData.gst ? <span>{rowData.gst}%</span> : "Nil"}</div>;
      },
    },
    {
      title: "CESS",
      render: (rowData) => {
        return <div>{rowData.cess ? <span>{rowData.cess}%</span> : "Nil"}</div>;
      },
    },
    {
      title: "Additional cess",
      render: (rowData) => {
        return (
          <div>
            {rowData.additionalcess ? (
              <span>{rowData.additionalcess}%</span>
            ) : (
              "Nil"
            )}
          </div>
        );
      },
    },
    {
      title: "IGST",
      render: (rowData) => {
        return <div>{rowData.igst ? <span>{rowData.igst}%</span> : "Nil"}</div>;
      },
    },
    {
      title: "Action",
      render: (rowData) => {
        return (
          <div
            style={{
              textAlign: "right",
            }}
          >
            <Button
              style={{
                width: "90px",
                marginRight: "auto",
              }}
              type="primary"
              onClick={() => {
                const isAccess = access.editTax();
                if (!isAccess) {
                  return;
                }
                handleEdit(rowData);
              }}
            >
              Edit
            </Button>
          </div>
        );
      },
    },
  ]);
  const handleEdit = (rowData) => {
    setInitialValues(rowData);
    setShow(true);
    setMode("edit");
  };
  const handleAdd = () => {
    setMode("add");
    setShow(true);
  };

  const handleAddCustomTax = async (values) => {
    const customTaxName = values.customTaxName;
    console.log("initialValues", customTaxName, initialValues);
    setTaxLoading(true);
    try {
      var res = await fetch(`${config.newApiGateway}/taxMaster/taxMaster`, {
        method: "POST",
        body: JSON.stringify({
          action: mode === "add" ? "customTaxType" : "editCustomTaxType",
          taxTypeId: mode === "add" ? undefined : initialValues.taxId,
          shopId: shopDetails.shopId,
          customTaxType: customTaxName,
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      });
      res = await res.json();
      if (res.code === "ERROR") {
        return alert(res.message);
      }
      if (res.code === "SUCCESS") {
        message.success(
          mode === "add"
            ? "Custom Tax Type Added Successfully"
            : "Custom Tax Type Updated Successfully"
        );
        dispatch({
          type: "SET_TAX_TYPE",
          payload: res.data.Attributes.customTaxType,
        });
        setCustomTaxName("");
        setOpen(false);
        form.resetFields();
      }
    } catch (err) {
      console.log(err);
      message.error("Error while Adding Tax. Please try again.");
    } finally {
      setCustomTaxName("");
      setMode("add");
      setInitialValues({});
      setTaxLoading(false);
    }
  };

  const fetchTaxsList = async (shopId) => {
    try {
      var res = await fetch(`${config.newApiGateway}/taxMaster/taxMaster`, {
        method: "POST",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          action: "fetchTaxmaster",
          shopId: shopId,
        }),
      });
      res = await res.json();
      console.log("taxmaster res", res);
      if (res.code === "ERROR") {
        return;
      }
      setTaxList(res.data);
      dispatch({
        type: "SET_TAX_LIST",
        payload: res.data,
      });
    } catch (e) {
      console.log("fetchTaxsList", e);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (shopId) fetchTaxsList(shopId);
  }, [shopId]);

  useEffect(() => {
    if (customTaxType.length > 0) {
      const customTaxTypeColumns = customTaxType.map((i) => {
        return {
          title: i.label,
          dataIndex: i.label,
          render: (label) => {
            return (
              <div>
                <span>{label ? capitalize(label) + "%" : "Nil"}</span>
              </div>
            );
          },
        };
      });
      const tempColumns = [...tableColumns];
      tempColumns.splice(6, 0, ...customTaxTypeColumns);
      setTableColumns(tempColumns);
    }
  }, [customTaxType]);

  console.log("customTaxType22", customTaxType);

  const handleEditTaxType = (i) => {
    setMode("edit");
    form.setFieldValue("customTaxName", i.label);
    setInitialValues(i);
    setCustomTaxName(i.label);
  };

  return (
    <>
      <div>
        <Card
          bodyStyle={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
          }}
          style={{
            marginBottom: 20,
          }}
        >
          <Button
            style={{
              marginRight: 8,
            }}
            type="primary"
            onClick={() => {
              const isAccess = access.customTaxType();
              if (!isAccess) {
                return;
              }
              setOpen(true);
            }}
          >
            Custom Tax Type
          </Button>
          <Button
            type="primary"
            onClick={() => {
              const isAccess = access.createTax();
              if (!isAccess) {
                return;
              }
              handleAdd();
            }}
          >
            Create Tax
          </Button>
        </Card>
        <CustomTable
          title={"Tax Master"}
          loading={loading}
          columns={tableColumns}
          data={taxList}
        />
      </div>
      <Modal open={open} onCancel={() => setOpen(false)} footer={false}>
        <Form
          name="customTax"
          labelCol={{
            span: 24,
          }}
          form={form}
          wrapperCol={{
            span: 24,
          }}
          onFinish={(values) => {
            if (!access.createCustomTax(false) && mode === "add") {
              return alert(
                "You don't have access to add this Tax Type, please contact your administrator to request the appropriate access."
              );
            }
            if (!access.editCustomTax(false) && mode === "edit") {
              return alert(
                "You don't have access to edit this Tax Type, please contact your administrator to request the appropriate access."
              );
            }
            handleAddCustomTax(values);
          }}
        >
          <Row gutter={[10, 10]}>
            <Col span={24}>
              <Form.Item
                name="customTaxName"
                label={<h5>Custom Tax Type</h5>}
                rules={[
                  {
                    required: true,
                    message: "Enter Tax Name",
                  },
                  {
                    min: 1,
                    max: 6,
                    message: "Tax Name must be between 1 to 6 characters",
                  },
                  {
                    validator: (_, value) => {
                      if (
                        customTaxType.some(
                          (i) => i.label.toLowerCase() === value.toLowerCase()
                        )
                      ) {
                        return Promise.reject(
                          "Tax Name already exists. Please enter a different name"
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input maxLength={6} placeholder="Enter Tax Name" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="">
                <Button
                  style={{
                    width: "100%",
                    textAlign: "center",
                  }}
                  htmlType="submit"
                  loading={taxLoading}
                  disabled={taxLoading}
                  type="primary"
                >
                  <PlusOutlined />
                  {mode === "edit" ? "Update" : "Add"}
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Row gutter={[10, 10]}>
          {customTaxType.map((i) => (
            <Col span={12}>
              <Card>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography.Text>{i.label}</Typography.Text>
                  <button
                    style={{
                      background: "none",
                      border: 0,
                      boxShadow: "none",
                    }}
                    onClick={() => {
                      if (!access.editCustomTax(false)) {
                        return alert(
                          "You don't have access to edit this Tax Type, please contact your administrator to request the appropriate access."
                        );
                      }
                      handleEditTaxType(i);
                    }}
                  >
                    <Tooltip title="Edit">
                      <FiEdit size={20} />
                    </Tooltip>
                  </button>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </Modal>
      <TaxmasterForm
        initialValues={mode === "add" ? {} : initialValues}
        mode={mode}
        show={show}
        setShow={setShow}
        fetchTaxsList={fetchTaxsList}
      />
    </>
  );
};

export default TaxMasterpage;
